import React from "react";

const HeartDisease = () => {
  return (
    <section
      className="mt-4 p-4 sm:p-6 gap-5 flex flex-col lg:flex-row mb-4 rounded-lg bg-white"
      style={{ marginTop: 20 }}
    >
      <div className="w-full lg:w-2/5 overflow-hidden">
        <img
          src="../assets/New-Hero//vision.png"
          alt="Heart"
          className="w-full h-auto object-contain rounded-lg"
        />
      </div>

      <div className="w-full lg:w-1/3 lg:-mt-20 px-4 lg:px-0">
        <h1
          // data-aos="fade-left"
          className="text-[#2d95a5] font-semibold text-xl lg:text-3xl mb-0 uppercase lg:mt-32 mt-8"
        >
         Mission
        </h1>
        <p
          data-aos="fade-left"
          className="text-gray-600 text-sm sm:text-base text-justify mt-2"
        >
         Provides patients with the necessary information, resources, and support to effectively manage diabetes. It also serves as an organ protection resource center for the patients.
        </p> 

        <h1
          // data-aos="fade-left"
          className="text-[#2d95a5] font-semibold text-xl lg:text-3xl mb-0 uppercase mt-8"
        >
         Vision
        </h1>
        <p
          data-aos="fade-left"
          className="text-gray-600 text-sm sm:text-base text-justify mt-2"
        >
           To empower patients to lead a healthy, fulfilling life through effectively managing diabetes. To create a culture of health and well-being that prioritizes the prevention of organ damage and minimizes the need for organ transplantation. 
        </p> 
      </div>
    </section>
  );
};

export default HeartDisease;
